const schemaScript = document.querySelector("#product-schema-data");
const reviews = document.querySelector(
	"#customer-reviews-block [data-bv-show]"
);
console.log("Product schema", reviews, schemaScript);

const updateSchema = (el) => {
	const ratingValue =
		el.querySelector('[itemprop="ratingValue"]')?.innerText || 0;
	const reviewCount =
		el.querySelector('[itemprop="reviewCount"]')?.getAttribute("content") || 0;
	if (ratingValue) {
		let json = JSON.parse(schemaScript.innerText);
		json.aggregateRating = {
			"@type": "AggregateRating",
			ratingValue,
			reviewCount,
		};
		schemaScript.innerHTML = JSON.stringify(json);
	}
};

const config = {
	attributes: true,
	childList: true,
	subtree: true,
};

if (reviews.getAttribute("data-bv-ready")) {
	console.log("attribute is there...");
	updateSchema(reviews);
} else {
	const callback = (mutations, observer) => {
		mutations.forEach((mutation) => {
			if (mutation.attributeName === "data-bv-ready") {
				updateSchema(reviews);
				observer.disconnect();
			}
		});
		console.log(mutations);
	};
	const observer = new MutationObserver(callback);
	observer.observe(reviews, config);
}
